// src/pages/HomePage.jsx
import React from 'react';
// import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const HomePage = () => {
    return (
        <div className="font-open text-black">
            {/* Navbar */}
            <header className="flex items-center justify-between px-6 md:px-12 py-4 shadow bg-white sticky top-0 z-50">
                <Link to="/" >
                    <h1 className="text-xl font-black">BecauseScience</h1>
                </Link>
                {/* <div className="space-x-4">
                    <button className="px-4 py-2 rounded-full bg-gray-200 text-sm font-medium">About</button>
                    <button className="px-4 py-2 rounded-full bg-yellow-400 text-sm font-medium">Subscribe</button>
                </div> */}
            </header>

            {/* Hero */}
            <section className="h-[500px] bg-black text-white text-center py-24 px-6 flex flex-col justify-center" style={{ backgroundImage: "url('/hex-pattern.svg')", backgroundRepeat: 'repeat' }}>
                <h2 className="text-3xl md:text-5xl font-semibold leading-snug max-w-4xl mx-auto">
                    Your everyday questions,<br />answered by science
                </h2>
            </section>

            {/* Banner */}
            <div className="bg-yellow-400 text-black text-center py-2 font-bold whitespace-nowrap overflow-x-auto text-sm md:text-base">
                <span className="inline-block animate-marquee px-6">follow your curiosity • follow your curiosity • follow your curiosity •</span>
            </div>

            {/* Episodes section */}
            {/* <section className="bg-gray-100 py-16 px-6 md:px-12"> */}
            {/* <h3 className="text-center text-lg font-semibold mb-6">Latest episodes</h3>
                <div className="text-center mb-12">
                    <span className="text-xl">↓</span>
                </div> */}

            {/* CRISPR Episode */}
            {/* <div className="bg-white rounded-lg shadow-lg overflow-hidden mb-10 flex flex-col md:flex-row">
                    <img src="/images/crispr-art.jpg" alt="CRISPR" className="w-full md:w-1/2 h-64 object-cover" />
                    <div className="p-6 md:w-1/2 flex flex-col justify-between">
                        <div>
                            <p className="text-sm font-semibold text-gray-500 mb-2">Episode 1</p>
                            <h4 className="text-2xl font-bold mb-4">CRISPR and You</h4>
                            <p className="text-base text-gray-700 mb-6">
                                Explore how CRISPR is revolutionizing genetics, what it means for human evolution, and whether we’re ready for designer DNA.
                            </p>
                        </div>
                        <Link
                            to="/crispr"
                            className="ml-auto mt-4 w-10 h-10 bg-yellow-400 rounded-full flex items-center justify-center hover:bg-yellow-300"
                        >
                            <ArrowRight />
                        </Link>
                    </div>
                </div> */}

            {/* Coming soon */}
            {/* <div className="text-center text-gray-600 mb-6">Coming soon</div>
                <div className="space-y-4">
                    <div className="bg-gray-300 text-center py-8 font-bold text-xl">Episode 2 - The Moon</div>
                    <div className="bg-gray-300 text-center py-8 font-bold text-xl">Episode 3 - Gut Check</div>
                </div> */}
            {/* </section> */}

            {/* Newsletter Section */}
            {/* <section className="bg-black text-white py-16 px-6 text-center">
                <h3 className="text-2xl md:text-3xl font-bold mb-4">New articles every month</h3>
                <p className="mb-6">Subscribe today to receive a monthly email straight to your inbox.</p>
                <div className="flex justify-center gap-2 flex-wrap">
                    <input
                        type="email"
                        placeholder="Never miss an episode"
                        className="px-4 py-2 rounded-full text-black w-64"
                    />
                    <button className="bg-yellow-400 text-black px-4 py-2 rounded-full hover:bg-yellow-300">
                        <ArrowRight />
                    </button>
                </div>
            </section> */}

            {/* Footer */}
            {/* <footer className="bg-black text-white py-12 px-6 md:px-12">
                <div className="flex flex-col md:flex-row justify-between items-center">
                    <div className="mb-4 md:mb-0">
                        <h4 className="text-2xl font-bold">BecauseScience</h4>
                        <p className="text-sm">Follow your curiosity</p>
                    </div>
                    <div className="flex items-center gap-4">
                        <input
                            type="email"
                            placeholder="Never miss an episode"
                            className="px-4 py-2 rounded-full text-black"
                        />
                        <button className="bg-yellow-400 px-4 py-2 rounded-full hover:bg-yellow-300">
                            <ArrowRight />
                        </button>
                    </div>
                </div>
                <div className="border-t border-gray-700 my-6" />
                <div className="text-xs text-center">© 2024 Because Science. A product of Arizona State University. All rights reserved</div>
            </footer> */}
        </div>
    );
};

export default HomePage;
